import loansService from '../../services/loan.service';
import { LoanDocuments, LoanDocumentsErrors } from '../../gql/graphql';
import { NetworkError } from '../../state-machine/actions/genericActions';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';

export interface GetLoanDocsResult {
  loanDocs?: LoanDocuments;
  loanDocsError?: LoanDocumentsErrors[];
}

const getLoanDocs = async (orderId: string) => {
  try {
    const response: any = await loansService.getLoanDocs(orderId);

    if (response.data?.generateLoanContract?.loanDocumentsErrors?.length) {
      return {
        loanDocsError: response.data.generateLoanContract.loanDocumentsErrors,
      };
    } else {
      return {
        loanDocs: response.data.generateLoanContract.loanDocuments,
      };
    }
  } catch (err: any) {
    let error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        error.errorGeneral = err;
    }
    throw error;
  }
};

export default getLoanDocs;
